<template>
  <div class="xingji">
    <div class="thisTitle">
        <span class="thisIcon">
          <img src="../../common/images/icon-xingjilogo.png" alt=""/>
        </span>
      <span>星级</span>
    </div>

    <div class="starBody">
      <div class="starSet" v-for="(item,index) in infoArr" :key="index">
        <div class="starSetTitle">{{item.masterName}}</div>
        <div class="starSetTitleTag" v-if="!isEdit">
          <span v-if="item.long.length > 0">
            <span class="tag-item long">长</span>长促
          </span>
          <span v-if="item.short.length > 0">
            <span class="tag-item">短</span> 短促
          </span>
        </div>
        <div class="starSetTitleTag" v-if="isEdit">
          <el-checkbox :checked="item.long.length>0" @change="changeState(item.masterId,'1')">长促</el-checkbox>
          <el-checkbox :checked="item.short.length>0" @change="changeState(item.masterId,'2')">短促</el-checkbox>
        </div>
        <div class="starContainer" v-if="item.long.length>0">
          <div class="headPortrait">
            <span class="tag-item big short">长</span>
            <span>长促</span>
            <i class="el-icon-arrow-right"></i>
          </div>
          <div class="list myForm">
            <table v-loading="loading">
              <tr style="background-color: #f8f8f8">
                <th width="100px" style="padding: 8px">{{item.masterId == 128 ? '人数区间' : '分值区间'}}</th>
                <th v-for="(item2,index2) in item.long" width="130" class="jujian">
                  <div class="showDiv" v-if="!isEdit">
                    {{item2.scoreMin}} <i v-if="item.masterId == 135 ||item.masterId == 136">%</i>
                  </div>
                  <span v-if="!isEdit">-</span>
                  <div class="showDiv" v-if="!isEdit">
                    {{item2.scoreMax}} <i v-if="item.masterId == 135 ||item.masterId == 136">%</i>
                  </div>
                  <div style="width: 100px;margin: 0 auto" v-if="isEdit">
                    <el-form :model="item2" :rules="rules" label-width="50px" class="demo-ruleForm">
                      <el-form-item prop="scoreMin">
                        <el-input v-model="item2.scoreMin" auto-complete="off"
                                  :placeholder="item.masterId == 135 ||item.masterId ==  136 ? '%':'分'"
                                  @change="changeValue()"></el-input>
                      </el-form-item>
                    </el-form> -
                    <el-form :model="item2" :rules="rules" label-width="50px" class="demo-ruleForm">
                      <el-form-item prop="scoreMax">
                        <el-input v-model="item2.scoreMax" auto-complete="off"
                                  :placeholder="item.masterId == 135 ||item.masterId ==  136 ? '%':'分'"
                                  @change="changeValue()"></el-input>
                      </el-form-item>
                    </el-form>
                  </div>
                </th>
                <th></th>
                <th class="pointer" rowspan="2" width="50px" v-if="item.long.length < 8 && isEdit"
                    @click="addInfo(item.masterId,1)">
                  <img src="../../../src/common/images/+.png" alt=""/>
                </th>
                <th class="pointer" rowspan="2" width="50px" v-if="item.long.length > 1 && isEdit"
                    @click="reduceInfo(item.masterId,'1')"> —
                </th>
              </tr>
              <tr>
                <td style="padding: 8px">{{item.masterId == 128 ? '人数设定' : '分值设定'}}</td>
                <td v-for="(item2,index2) in item.long" width="130">
                  <div v-if="!isEdit">{{item2.score}}</div>
                  <el-form :model="item2" label-width="50px" class="demo-ruleForm" v-if="isEdit">
                    <el-form-item
                        prop="score"
                        :rules="[{ required: true,message:'*'},{ pattern: /^\d{1,4}$/, message: '*' }]">
                      <el-input type="age" v-model.number="item2.score" auto-complete="off" placeholder="请输入分数"
                                @change="changeValue()"></el-input>
                    </el-form-item>
                  </el-form>
                </td>
                <td></td>
              </tr>
            </table>
          </div>
        </div>
        <div class="starContainer" v-if="item.short.length>0">
          <div class="headPortrait">
            <span class="tag-item big">短</span>
            <span>短促</span>
            <i class="el-icon-arrow-right"></i>
          </div>
          <div class="list myForm">
            <table v-loading="loading">
              <tr style="background-color: #f8f8f8">
                <th width="100px" style="padding: 8px">{{item.masterId == 128 ? '人数区间' : '分值区间'}}</th>
                <th v-for="(item2,index2) in item.short" width="130" class="jujian">
                  <div class="showDiv" v-if="!isEdit">{{item2.scoreMin}}<i
                      v-if="item.masterId == 135 ||item.masterId == 136">%</i></div>
                  <span v-if="!isEdit">-</span>
                  <div class="showDiv" v-if="!isEdit">{{item2.scoreMax}}<i
                      v-if="item.masterId == 135 ||item.masterId == 136">%</i></div>
                  <div style="width: 100px;margin: 0 auto" v-if="isEdit">
                    <el-form :model="item2" :rules="rules" label-width="50px" class="demo-ruleForm">
                      <el-form-item prop="scoreMin">
                        <el-input v-model="item2.scoreMin" auto-complete="off"
                                  :placeholder="item.masterId == 135 ||item.masterId ==  136 ? '%':'分'"
                                  @change="changeValue()"></el-input>

                      </el-form-item>
                    </el-form>
                    -
                    <el-form :model="item2" :rules="rules" label-width="50px" class="demo-ruleForm">
                      <el-form-item prop="scoreMax">
                        <el-input v-model="item2.scoreMax" auto-complete="off"
                                  :placeholder="item.masterId == 135 ||item.masterId ==  136 ? '%':'分'"
                                  @change="changeValue()"></el-input>
                      </el-form-item>
                    </el-form>
                  </div>
                </th>
                <th></th>
                <th class="pointer" rowspan="2" width="50px" v-if="item.short.length < 8 && isEdit"
                    @click="addInfo(item.masterId,2)">
                  <img src="../../../src/common/images/+.png" alt=""/>
                </th>
                <th class="pointer" rowspan="2" width="50px" v-if="item.short.length > 1 && isEdit"
                    @click="reduceInfo(item.masterId,'2')">
                  —
                </th>
              </tr>
              <tr>
                <td style="padding: 8px">{{item.masterId == 128 ? '人数设定' : '分值设定'}}</td>

                <td v-for="(item2,index2) in item.short" width="130">
                  <div v-if="!isEdit">{{item2.score}}</div>
                  <el-form :model="item2" label-width="50px" class="demo-ruleForm" v-if="isEdit">
                    <el-form-item
                        prop="score"
                        :rules="[{ required: true,message:'*'},{ pattern: /^\d{1,4}$/, message: '*' }]">
                      <el-input type="age" v-model.number="item2.score" auto-complete="off" placeholder="请输入分数"
                                @change="changeValue()"></el-input>
                    </el-form-item>
                  </el-form>
                </td>
                <td></td>
              </tr>
            </table>
          </div>
        </div>
      </div>

      <div class="starSet danxuan" v-for="(item,index) in danXuanArr">
        <div class="starSetTitle">
          {{item.masterName}}
          <div class="valueSetting">
            分值设定：
            <div v-if="!isEdit" style="display: inline-block">
              {{item.score}}
            </div>
            <div style="display: inline-block" v-if="isEdit">
              <el-form :model="item" :rules="rules" label-width="50px" class="demo-ruleForm">
                <el-form-item prop="score">
                  <el-input v-model="item.score" auto-complete="off" placeholder="请输入分数" :maxlength="4"
                            @change="changeValue()"></el-input>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
      </div>

      <div class="starSet">
        <div class="starSetTitle">
          星级设定
        </div>
        <div class="starContainer myForm">
          <table v-loading="loading">
            <tr style="background-color: #f8f8f8">
              <th width="100px" style="padding: 8px">分值区间</th>
              <th v-for="(item,index) in starSetArr" width="130">
                <div class="showDiv" v-if="!isEdit">{{item.scoreMin}}</div>
                <span v-if="!isEdit">-</span>
                <div class="showDiv" v-if="!isEdit">{{item.scoreMax}}</div>
                <div style="width: 100px;margin: 0 auto" class="jujian" v-if="isEdit">
                  <el-form :model="item" label-width="50px" class="demo-ruleForm">
                    <el-form-item
                        prop="scoreMin"
                        :rules="[{ required: true,message:'*'},{ pattern: /^\d{1,4}$/, message: '*' }]">
                      <el-input type="age" v-model.number="item.scoreMin" auto-complete="off" placeholder="分"
                                @change="changeValue()" :maxlength="4"></el-input>
                    </el-form-item>
                  </el-form> -
                  <el-form :model="item" label-width="50px" class="demo-ruleForm">
                    <el-form-item
                        prop="scoreMax"
                        :rules="[{ required: true,message:'*'},{ pattern: /^\d{1,4}$/, message: '*' }]">
                      <el-input type="age" v-model.number="item.scoreMax" auto-complete="off" placeholder="分"
                                @change="changeValue()"></el-input>
                    </el-form-item>
                  </el-form>
                </div>
              </th>
              <th></th>
              <th class="pointer" rowspan="2" width="50px" v-if="starSetArr.length < 8 && isEdit" @click="addStar()">
                <img src="../../../src/common/images/+.png" alt=""/>
              </th>
              <th class="pointer" rowspan="2" width="50px" v-if="starSetArr.length >1 && isEdit" @click="reduceStar()">
                —
              </th>
            </tr>
            <tr>
              <td style="padding: 8px">星级名称</td>
              <td v-for="(item,index) in starSetArr">
                <div v-if="!isEdit">
                  {{item.starName}}
                </div>
                <el-form :model="item" label-width="50px" class="demo-ruleForm" v-if="isEdit">
                  <el-form-item
                      prop="starName">
                    <el-input type="age" v-model.number="item.starName" auto-complete="off" placeholder="请输入文字"
                              @change="changeValue()"></el-input>
                  </el-form-item>
                </el-form>
              </td>
              <td></td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapMutations} from 'vuex'
  import utils from '../../common/js/util'

  export default {
    props: ['isEdit'],
    name: '',

    data() {
      var checkNum = (rule, value, callback) => {
        if (isNaN(Number(value))) {
          callback(new Error('*'));
        } else if (value == '') {
          callback(new Error('*'));
        } else {
          callback();
        }
      };
      return {
        tableData: [],
        starSetArr: [],
        infoArr: [],
        starArr: [],
        danXuanArr: [],
        num: 1,
        loading: false,
        rules: {
          score: [{validator: checkNum, trigger: 'blur'}],
          scoreMin: [{validator: checkNum, trigger: 'blur'}],
          scoreMax: [{validator: checkNum, trigger: 'blur'}],
        },
      }
    },
    mounted() {
      console.log('星级', this.$store.state.xingJiArr)
      if (this.$store.state.xingJiArr == '') {
        this.getData()
      } else {
        this.getVuex()
      }

      if (this.$store.state.xingJiEdit == '') {
        this.getStar()
      } else {
        this.starSetArr = this.$store.state.xingJiEdit
      }
    },
    methods: {
      ...mapMutations(['changeXingJiArr', 'changeXingJiEditArr', 'changeSortStar']),
      // isInArr (arr, item, flag) {
      //   for(var i = 0; i < arr.length; i++) {
      //     if (arr[i][flag] === item[flag]) {
      //       return i
      //     }
      //     return false
      //   }
      // },
      getData() {
        this.loading = true
        this.$http({
          method: "get",
          url: '/rest/ScoreSystemSettings/searchScore?scoreType=2',
        }).then(res => {
          //获取第一页选的所有2
          var danXuanArr = []
          this.$store.state.systemArr.map((item, index) => {
            let exceptArr = [118, 119, 120, 121, 122, 123, 124, 125, 127, 128, 129, 130, 131]
            if (item.scoreType == 2) {
              if (exceptArr.indexOf(item.masterId) < 0) {
                this.starArr.push(item)
              } else {
                danXuanArr.push(item)
              }
            }
          })
          // this.danXuanArr = danXuanArr
          //初始化数组
          danXuanArr.map((item, index) => {
            this.danXuanArr[index] = {
              masterId: item.masterId,
              masterName: item.masterName,
              score: item.score,
              longSign: item.signId,
              shortSign: item.signId,
              signId: item.signId,
            }
          })

          this.danXuanArr.map((item, index) => {
            let long = item.longSign
            if (long == -1 || long == 2) {
              item.longSign = false
            } else if (long == 0 || long == 1) {
              item.longSign = true
            }
            let short = item.shortSign
            if (short == -1 || short == 1) {
              item.shortSign = false
            } else if (short == 0 || short == 2) {
              item.shortSign = true
            }
          })

          this.starArr.map((item, index) => {
            this.infoArr[index] = {
              masterId: item.masterId,
              masterName: item.masterName,
              long: [],
              short: [],
            }
          })

          this.tableData = res.data

          this.tableData.map((item, index) => {
            this.infoArr.map((item2, index2) => {
              if (item2.masterId == item.masterId && item.signId == 1) {
                item2.long.push(item)
              } else if (item2.masterId == item.masterId && item.signId == 2) {
                item2.short.push(item)
              }
            })
            this.danXuanArr.map((item2, index2) => {
              if (item2.masterId == item.masterId) {
                item2.score = item.score
                item2.signId = item.signId
              }
            })
          })

          this.loading = false
        }).catch(err => {
          utils.myNotify(this, 'error', err.response, '查询失败，请稍后重试')
          this.loading = false
        })
      },
      getVuex() {
        //获取第一页选的所有2
        var danXuanArr = []
        this.$store.state.systemArr.map((item, index) => {
          if (item.scoreType == 2 && item.masterId != 118 && item.masterId != 119 && item.masterId != 120 && item.masterId != 121 && item.masterId != 122 && item.masterId != 123 && item.masterId != 124 && item.masterId != 125 && item.masterId != 127 && item.masterId != 128 && item.masterId != 129 && item.masterId != 130 && item.masterId != 131) {
            this.starArr.push(item)
          }
          if (item.masterId == 118 && item.scoreType == 2 || item.masterId == 119 && item.scoreType == 2 || item.masterId == 120 && item.scoreType == 2 || item.masterId == 121 && item.scoreType == 2 || item.masterId == 122 && item.scoreType == 2 || item.masterId == 123 && item.scoreType == 2 || item.masterId == 124 && item.scoreType == 2 || item.masterId == 125 && item.scoreType == 2 || item.masterId == 127 && item.scoreType == 2 || item.masterId == 128 && item.scoreType == 2 || item.masterId == 129 && item.scoreType == 2 || item.masterId == 130 && item.scoreType == 2 || item.masterId == 131 && item.scoreType == 2) {
            danXuanArr.push(item)
          }
        })

        //初始化数组
        danXuanArr.map((item, index) => {
          this.$store.state.xingJiArr.map((item2, index) => {
            if (item.masterId == item2.masterId) {
              item.score = item2.score
              item.longSign = item2.longSign
              item.shortSign = item2.shortSign
              item.signId = item2.signId
            }
          })
        })

        this.danXuanArr = danXuanArr

        this.starArr.map((item, index) => {
          this.$set(this.infoArr, index, {
            masterId: item.masterId,
            masterName: item.masterName,
            long: [],
            short: [],
          })
        })

        this.tableData = this.$store.state.xingJiArr

        this.tableData.map((item, index) => {
          this.infoArr.map((item2, index2) => {
            if (item2.masterId == item.masterId && item.signId == 1) {
              item2.long.push(item)
            } else if (item2.masterId == item.masterId && item.signId == 2) {
              item2.short.push(item)
            }
          })
        })
      },
      getStar() {
        this.$http({
          method: "get",
          url: '/rest/ScoreSystemSettings/searchStar'
        }).then(res => {
          this.starSetArr = res.data
        }).catch(err => {
          utils.myNotify(this, 'error', err.response, '查询失败，请稍后重试')
        })
      },
      changeState(masterId, choose) {
        this.num++
        this.infoArr.map((item, index) => {
          if (item.masterId == masterId) {
            if (choose == 1) {
              if (item.long.length > 0) {
                item.long = []
              } else {
                item.long.push({
                  scoreMax: '',
                  scoreMin: '',
                  score: '',
                  signId: 1,
                  scoreType: 2,
                })
              }
            }
            if (choose == 2) {
              if (item.short.length > 0) {
                item.short = []
              } else {
                item.short.push({
                  scoreMax: '',
                  scoreMin: '',
                  score: '',
                  signId: 2,
                  scoreType: 2,
                })
              }
            }
          }
        })
        this.save()
      },
      addInfo(masterId, signId) {
        this.num++
        this.infoArr.map((item, index) => {
          if (item.masterId == masterId) {
            if (signId == 1) {
              item.long.push({
                "masterId": masterId,
                "scoreMax": '',
                "scoreMin": '',
                "score": '',
                "scoreType": 2,
                "startTime": this.$store.state.startTime,
                "signId": 1,
              })
            } else if (signId == 2) {
              item.short.push({
                "masterId": masterId,
                "scoreMax": '',
                "scoreMin": '',
                "score": '',
                "scoreType": 2,
                "startTime": this.$store.state.startTime,
                "signId": 2,
              })
            }
          }
        })
        this.save()
      },
      reduceInfo(masterId, signId) {
        this.num++
        this.infoArr.map((item, index) => {
          if (item.masterId == masterId) {
            if (signId == 1) {
              item.long.splice(item.long.length - 1, 1)
            } else if (signId == 2) {
              item.short.splice(item.short.length - 1, 1)
            }
          }
        })
        this.save()
      },
      changeMan(type, item) {
        if (type == 1) {
          item.longSign = !item.longSign
        }
        if (type == 2) {
          item.shortSign = !item.shortSign
        }
        this.save()
      },
      addStar() {
        this.num++
        this.starSetArr.push({
          scoreMax: '',
          scoreMin: '',
          starName: '',
          startTime: this.$store.state.startTime
        })
        this.save()
      },
      reduceStar() {
        this.num++
        this.starSetArr.splice(this.starSetArr.length - 1, 1)
        this.save()
      },
      changeValue() {
        console.log(456)
        this.save()
      },
      save() {
        console.log(123)
        this.changeSortStar(this.infoArr)
        var arr = []
        this.infoArr.map((item, index) => {
          item.long.map((item2, index2) => {
            arr.push({
              masterId: item.masterId,
              scoreMax: item2.scoreMax,
              scoreMin: item2.scoreMin,
              signId: item2.signId,
              score: item2.score,
              scoreType: 2,
              startTime: this.$store.state.startTime
            })
          })
          item.short.map((item2, index2) => {
            arr.push({
              masterId: item.masterId,
              scoreMax: item2.scoreMax,
              scoreMin: item2.scoreMin,
              signId: item2.signId,
              score: item2.score,
              scoreType: 2,
              startTime: this.$store.state.startTime
            })
          })
        })

        this.danXuanArr.map((item, index) => {
          if (item.longSign == true && item.shortSign == true) {
            item.signId = 0
          } else if (item.longSign == true && item.shortSign == false) {
            item.signId = 1
          } else if (item.longSign == false && item.shortSign == true) {
            item.signId = 2
          } else {
            item.signId = -1
          }
        })

        this.danXuanArr.map((item, index) => {
          arr.push(item)
        })

        this.changeXingJiArr(arr)
        this.changeXingJiEditArr(this.starSetArr)
      },
    }
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .thisIcon {
    width: 20px;
    height: 20px;
    display: inline-block;
    vertical-align: middle;
    border-radius: 50%;
    margin-right: 10px;
  }

  .thisTitle span:last-child {
    font-size: 15px;
    vertical-align: middle;
    font-weight: bold;
    margin-bottom: 10px;
  }

  .starSet {
    position: relative;
  }

  .starSetTitle {
    padding: 10px 20px;
    background-color: #8299dc;
    color: white;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    margin-top: 10px;
    position: relative;
  }

  .starBody {
    margin: 10px 0;
  }

  .starContainer {
    padding: 20px;
    background-color: white;
  }

  .starContainer > div > div {
    display: inline-block;
  }

  .tag-item {
    display: inline-block;
    width: 20px;
    height: 20px;
    background: white;
    border-radius: 50%;
    text-align: center;
    margin-right: 10px;
    color: #8cc18b;
    line-height: 20px;
  }

  .long {
    color: #839bdb;
  }

  .starSetTitleTag {
    color: white;
    position: absolute;
    top: 10px;
    right: 30px;
  }

  .starSetTitleTag > div {
    display: inline-block;
    margin-left: 30px;
  }

  .starSetTitleTag > span {
    margin-left: 30px;
  }

  .big {
    background-color: #829ada;
    color: white;
    width: 40px;
    height: 40px;
    line-height: 40px;
    vertical-align: middle;
  }

  .list {
    display: inline-block;
    width: 88%;
    margin-left: 40px;
    vertical-align: middle;
  }

  .short {
    background-color: #81bc82;
  }

  .valueSetting {
    position: absolute;
    left: 134px;
    background: white;
    color: black;
    top: 5px;
    padding: 3px 20px;
    border-radius: 15px;
  }

  table {
    width: 100%;
  }

  th, td {
    border: 1px solid #e6ebf5;
  }

  td {
    border-top: none;
    text-align: center;
  }

  th {
    font-weight: normal;
  }

  input {
    width: 50px;
  }

  .showDiv {
    width: 40px;
    height: 20px;
    line-height: 20px;
    display: inline-block;
  }

  .headPortrait {
    display: inline-block;
  }
</style>




// WEBPACK FOOTER //
// src/views/Assessment/XingJI.vue